export const errorTranslation = {
  'There are not enough funds to carry out this operation.': 'Не вистачає коштів для проведення цієї операції.',
  'There are not enough funds on the balance sheet of the branch to carry out this departments.': 'На балансі відділення не вистачає коштів для здійснення цієї операції.'
};
